import { useQuery } from "react-query";

import courses from "../tempData/oldEventsExport.json";

/* Note that field for series likely needs to be udpated */
const coursesMapping = (course) => ({
	description: course.classFullDescription,
	end: new Date(`${course.classDate} ${course.endHH}:${course.endMM} ${course.endAMPM}`.replace(/-/gu, "/")),
	facilitator: course.classDateFacilitatorID,
	id: course.classDateID,
	series: course.classNameAbbrev,
	start: new Date(`${course.classDate} ${course.startHH}:${course.startMM} ${course.startAMPM}`.replace(/-/gu, "/")),
	title: course.className
});

export const getCourses = (filters = {}) => {

	const cacheTime = 1000 * 60 * 10;

	return useQuery(
		["all-events", filters],
		() => new Promise((resolve) => {
			let mappedCourses = courses.map(coursesMapping);

			if (filters.search) {
				mappedCourses = mappedCourses.filter((course) => course.title.toLowerCase().search(filters.search.toLowerCase()) !== -1);
			}

			if (filters.facilitator) {
				mappedCourses = mappedCourses.filter((course) => String(course.facilitator) === String(filters.facilitator));
			}

			resolve(mappedCourses);
		}),
		{
			cacheTime,
			keepPreviousData: true,
			staleTime: cacheTime
		}
	);
};

export const getCourse = (courseId) => {

	const cacheTime = 1000 * 60 * 10;

	return useQuery(
		["course", courseId],
		() => new Promise((resolve, reject) => {
			const currentCourse = courses.filter((course) => course.classDateID === courseId);

			if (currentCourse.length) {
				resolve(currentCourse.map(coursesMapping)[0]);
			} else {
				reject(new Error("No class found!"));
			}
		}),
		{
			cacheTime,
			staleTime: cacheTime
		}
	);
};

/*
 * Current course data doesn't have a specified field for series.
 * I'm using the abbreviated class name as a stand in for now.
 * But this will need to be revisited.
 */
export const getCoursesBySeries = (seriesId) => {

	const cacheTime = 1000 * 60 * 10;

	return useQuery(
		["series", seriesId],
		() => new Promise((resolve, reject) => {
			const series = courses.filter((course) => course.classNameAbbrev === seriesId);

			if (series.length) {
				resolve(series.map(coursesMapping));
			} else {
				reject(new Error("No classes in this series!"));
			}
		}),
		{
			cacheTime,
			enabled: !!seriesId, // eslint-disable-line
			staleTime: cacheTime
		}
	);
};
